export function EmptyText() {
    return <>-</>;
}
